export interface IAlert  {
    message: string,
    title: string,
    severity: string,
    strongTitle: string,
}

export const InitialAlert: IAlert = {
    message: "",
    title: "",
    severity: "Alerta",
    strongTitle: "Alerta"
}
